import { Switch } from 'antd'
import type { SwitchProps } from 'antd'
import React from 'react'
import styled from 'styled-components'

export const BasSwitch: React.FC<SwitchProps> = props => <StyledSwitch size="small" {...props} />

const StyledSwitch = styled(Switch)`
  min-width: 20px;
  height: 8px;
  line-height: 8px;
  background-color: #999999;

  .ant-switch-handle {
    top: -2px;
    left: -2px;

    &::before {
      background-color: #fff;
      border-radius: 6px;
    }
  }

  &.ant-switch-checked {
    background-color: #a7a2e6;

    .ant-switch-handle {
      left: calc(100% - 12px) !important;

      &::before {
        background-color: #4238c9;
        border-radius: 6px;
      }
    }
  }
`
